<div fxLayout="column" fxFlex fxLayoutGap="24px">
  <!-- Header -->
  <div fxLayout="row" fxLayoutAlign="space-between center">
    <h2>{{ create ? 'Create' : 'Edit' }} Key</h2>
    <button mat-icon-button [routerLink]="['../']" matTooltip="Back to list">
      <mat-icon>arrow_back</mat-icon>
    </button>
  </div>

  <form [formGroup]="form" (ngSubmit)="onSubmit()" fxLayout="column" fxLayoutGap="24px">
    <!-- Basic Information Card -->
    <mat-card>
      <mat-card-header>
        <mat-card-title>
          <mat-icon class="title-icon">info</mat-icon>
          Basic Information
        </mat-card-title>
        <mat-card-subtitle> Key identification and description </mat-card-subtitle>
      </mat-card-header>

      <mat-card-content>
        <div fxLayout="column" fxLayoutGap="16px">
          <mat-form-field appearance="outline">
            <mat-label>Key ID</mat-label>
            <input
              matInput
              formControlName="id"
              placeholder="Enter a unique identifier for this key"
            />
            <mat-icon matSuffix>tag</mat-icon>
            @if (form.get('id')?.hasError('required') && form.get('id')?.touched) {
              <mat-error>Key ID is required</mat-error>
            }
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>Description</mat-label>
            <input
              matInput
              formControlName="description"
              placeholder="Describe the purpose of this key"
            />
            <mat-icon matSuffix>description</mat-icon>
            @if (
              form.get('description')?.hasError('required') && form.get('description')?.touched
            ) {
              <mat-error>Description is required</mat-error>
            }
          </mat-form-field>
        </div>
      </mat-card-content>
    </mat-card>

    <!-- Private Key Card -->
    <mat-card>
      <mat-card-header>
        <mat-card-title>
          <mat-icon class="title-icon">security</mat-icon>
          Cryptographic Key
        </mat-card-title>
        <mat-card-subtitle> Private key for credential signing </mat-card-subtitle>
      </mat-card-header>

      <mat-card-content fxLayout="column" fxLayoutGap="16px">
        @if (create) {
          <h4>Private Key (JSON Web Key)</h4>
          <app-editor
            formControlName="privateKey"
            [schema]="jwkSchema"
            [errors]="form.get('privateKey')?.errors"
          ></app-editor>
        } @else {
          <mat-card class="info-card">
            <mat-card-content>
              <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="12px">
                <mat-icon class="warning-icon">security</mat-icon>
                <div>
                  <strong>Security Notice</strong>
                  <p class="info-text">
                    Private key is not displayed for security reasons and cannot be modified after
                    import.
                  </p>
                </div>
              </div>
            </mat-card-content>
          </mat-card>
        }
      </mat-card-content>
    </mat-card>

    <!-- Certificate Card -->
    <mat-card>
      <mat-card-header>
        <mat-card-title>
          <mat-icon>badge</mat-icon>
          Certificate (Optional)
        </mat-card-title>
        <mat-card-subtitle> X.509 certificate for public key verification </mat-card-subtitle>
      </mat-card-header>

      <mat-card-content fxLayout="column" fxLayoutGap="16px">
        <h4>Certificate (PEM Format)</h4>
        <app-editor
          formControlName="crt"
          [editorOptions]="editorOptionsPem"
          [errors]="form.get('crt')?.errors"
        ></app-editor>
      </mat-card-content>
    </mat-card>
    <mat-divider></mat-divider>
    <!-- Action Buttons -->
    <div fxLayout="row" fxLayoutGap="16px" fxLayoutAlign="end center">
      <button mat-button type="button" [routerLink]="['../']">Cancel</button>
      <button mat-flat-button type="submit" [disabled]="form.invalid">
        <mat-icon>{{ create ? 'add' : 'save' }}</mat-icon>
        {{ create ? 'Create' : 'Save' }} Key
      </button>
    </div>
    {{ form.errors | json }}
  </form>
</div>
